import Error from "next/error";
import dynamic from "next/dynamic";
import React from "react";
import { AREA_RISERVATA_PAGES } from "../config/areaRiservataPages";
import DeployManagement from "../config/deployManagement";

const RemotePage = dynamic(() => import("./remote-page/RemotePage"));

const RemotePageNoSSR = dynamic(() => import("./remote-page/RemotePage"), {
  ssr: false,
});

const isPrivatePage = (url: string) => {
  if (!url) return false;

  // 1. Prova il match diretto
  if (url in AREA_RISERVATA_PAGES) return true;

  // 2. Prova a rimuovere il prefisso /tpdweb se presente per il confronto
  const cleanUrl = url.replace(/^\/tpdweb/, "");
  
  // 3. Controlla se una qualsiasi chiave dell'oggetto "finisce" con il tuo URL 
  // o se il tuo URL normalizzato è presente tra le chiavi
  return Object.keys(AREA_RISERVATA_PAGES).some(key => {
    const cleanKey = key.replace(/^\/tpdweb/, "");
    return cleanKey === cleanUrl;
  });
};
//TODO REMOVE WHEN TO RELEASE IN PROD
const isNotProduction = DeployManagement.ENV_TO_DEPLOY !== DeployManagement.DEPLOY_ENV.PROD;

export default function DynamicPage(props: any = {}) {
  if (Object.keys(props).length === 0) {
    return <div></div>;
  } else {
    const { pageProps = {}, errorCode } = props;

    if (errorCode) {
      return <Error statusCode={errorCode} />;
    } 
    const isPrivate = isPrivatePage(pageProps.url);

    if (isNotProduction && isPrivate) {
      return <RemotePageNoSSR {...pageProps} />;
    }

    return <RemotePage {...pageProps} />;
  }
}
